import * as React from "react";
const SvgIcInput = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.5 5V8H7.5V20H10.5V8H15.5V5H2.5ZM21.5 10H12.5V13H15.5V20H18.5V13H21.5V10Z", fill: "currentColor" }));
export default SvgIcInput;
